document.addEventListener('DOMContentLoaded', function () {
  var stickyBars = document.querySelectorAll('[data-mobile-sticky-atc]');

  if (!stickyBars.length) {
    return;
  }

  stickyBars.forEach(function (bar) {
    var form = bar.closest('form');

    if (!form) {
      return;
    }

    var mainButton = form.querySelector('[data-add-to-cart]');
    var mainButtonText = form.querySelector('[data-add-to-cart-text]');
    var stickyButton = bar.querySelector('[data-sticky-atc-button]');
    var stickyButtonText = bar.querySelector('[data-sticky-atc-text]');
    var stickyPrice = bar.querySelector('[data-sticky-atc-price]');
    var productSection = form.closest('[data-section-type="product"]') || document;
    var livePrice = productSection.querySelector('[data-product-price]');
    var mobileQuery = window.matchMedia('(max-width: 768px)');
    var mainButtonVisible = true;
    var formTop = form.getBoundingClientRect().top + window.scrollY;

    if (!mainButton || !stickyButton || !stickyButtonText || !stickyPrice) {
      return;
    }

    function syncState() {
      if (mainButtonText) {
        stickyButtonText.textContent = mainButtonText.textContent.trim();
      }

      stickyButton.disabled = mainButton.disabled;

      if (livePrice) {
        stickyPrice.innerHTML = livePrice.innerHTML;
      }
    }

    function updateVisibility() {
      var isMobile = mobileQuery.matches;
      var scrolledPastForm = window.scrollY > formTop + 140;
      var nearPageBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 140;
      var shouldShow = isMobile && scrolledPastForm && !mainButtonVisible && !nearPageBottom;

      bar.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('has-mobile-sticky-atc', shouldShow);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        mainButtonVisible = entry.isIntersecting;
        updateVisibility();
      });
    }, {
      threshold: 0.35
    });

    observer.observe(mainButton);

    stickyButton.addEventListener('click', function (evt) {
      if (stickyButton.disabled) {
        evt.preventDefault();
        return;
      }

      if (mainButton !== stickyButton) {
        mainButton.click();
        evt.preventDefault();
      }
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', function () {
      formTop = form.getBoundingClientRect().top + window.scrollY;
      updateVisibility();
    });

    document.addEventListener('variant:change', function () {
      syncState();
      window.requestAnimationFrame(updateVisibility);
    });

    syncState();
    updateVisibility();
  });
});
